import React, { Component } from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"

class OurClients extends Component {
  render() {
    return (
      <section id="our-clients" className="text-center">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-header-pic">
                <h2 className="m-0">Our Clients</h2>
              </div>
            </div>
            <div className="col-12 pt-3 about-pb">
              <p className="lead text-white">
                Here are some of our clients who trusted us and we have build
                their
                <br />
                websites with our best efforts.
              </p>
            </div>

            <div className="col-12">
              <div className="products">
                <ul>
                  <li>
                    <a href="#">
                      <LazyLoadImage
                        className="img-responsive "
                        src={require("../../../static/images/partners/converge-magazine.png")}
                      />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <LazyLoadImage
                        className="img-responsive "
                        src={require("../../../static/images/partners/magnitude-wealth.png")}
                      />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <LazyLoadImage
                        className="img-responsive "
                        src={require("../../../static/images/partners/360s-photography.png")}
                      />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <LazyLoadImage
                        className="img-responsive "
                        src={require("../../../static/images/partners/hillari-mcqueen.png")}
                      />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <LazyLoadImage
                        className="img-responsive "
                        src={require("../../../static/images/partners/modularesi.png")}
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default OurClients
